<script setup lang="tsx">
const props = defineProps({
	id: String,
	dataID: String,
	class: String,
	title: String,
	href: String,
	dataTest: String,
	hoverColor: String,
	tooltip: {
		type: Boolean,
		default: true,
	},
	tooltipPlacement: {
		type: String,
		default: 'bottom',
	},
	disabled: {
		type: Boolean,
		default: false,
	},
	count: {
		type: Number,
		default: 0,
	},
	size: {
		type: String,
		default: '',
	},
})

const emit = defineEmits(['click'])
</script>

<template>
	<component
		:is="props.href ? 'a' : 'span'"
		:id="props.id"
		:href="props.href"
		:data-test="props.dataTest"
		:class="[
			props.disabled ? 'btn-icon-disabled' : 'btn-icon',
			props.class ? props.class : 'bi bi-star',
			props.size ? props.size : 'px-2 fs-3',
		]"
		v-one-tooltip="props.tooltip && props.title ? { content: props.title, placement: props.tooltipPlacement } : null"
		@click="!props.disabled && emit('click')"
		:style="{
			'--hover-color': props.hoverColor,
		}"
	>
		<div v-if="props.count > 0" class="rounded-circle count-badge">
			<span class="count-text">{{ props.count }}</span>
		</div>
	</component>
</template>

<style lang="sass" scoped>
@import ~bootstrap/scss/functions
@import ~bootstrap/scss/variables

.btn-icon
  color:  $secondary
  cursor: pointer
  border: none
  background-color: transparent
  opacity: 95%
  transition: color 0.3s ease, transform 0.2s ease-in-out
  &:hover
    color: var(--hover-color, $primary)
    transform: scale(1.1)
    opacity: 95%

.btn-icon-disabled
  color:  $secondary
  pointer-events: none
  opacity: 40%

.count-badge
  position: absolute
  bottom: 0
  right: 0
  width: 18px
  height: 18px
  background-color: $primary

.count-text
  font-size: 12px
  color: white
  font-weight: bold
  width: 100%
  text-align: center
  position: absolute
  left: 0
  bottom: 0
</style>
